import {Component, inject, OnInit} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc';

import {authentificationConfiguration} from '../../public-api';
import {parametresClient, RetournerCheminsApplication, ValLangueService, ValNavigationService} from '../../../../val-definitions-communes-lib/src/public-api';
import {ValAppSettingsService} from '../../../../val-ammon-services/val-app-settings-lib/src/public-api';
import {JetonContexteService} from '../jeton-contexte.service';

//Composant callback
@Component (
{
  selector: 'val-val-callback',
  imports: [],
  templateUrl: './val-callback.component.html',
  styleUrl: './val-callback.component.scss',
})
export class ValCallbackComponent implements OnInit
{
  private valLangueService = inject (ValLangueService);
  private navigationService = inject (ValNavigationService);
  private chemins = RetournerCheminsApplication ();

  //Création
  //  Paramètres
  //    oAuthService : Service d’authentification
  constructor (private oAuthService: OAuthService, private appSettingsService: ValAppSettingsService, private jetonContexteService: JetonContexteService) 
  {
    let issuer: string;
    let codeClient: string | null;
    
    codeClient = sessionStorage.getItem ("code_client") || null;

    if (codeClient)
    {
      parametresClient.code = codeClient;

      issuer = appSettingsService.Configuration.OpenIdConnect.Authority;
      issuer += "/realms/" + codeClient;

      authentificationConfiguration.issuer = issuer;
      authentificationConfiguration.clientId = "ammon-plateforme-ui";

      this.oAuthService.configure (authentificationConfiguration);
      this.oAuthService.setupAutomaticSilentRefresh ();
    }
  }

  //Initialise le composant
  //  Retourne
  //    Opération asynchrone
  public async ngOnInit () : Promise<void> 
  {
    let url = sessionStorage.getItem ("route_cible");
    
    if(!url)
      url = this.chemins.accueil;

    await this.oAuthService.loadDiscoveryDocumentAndTryLogin ();

    for (let tentative = 0; tentative < 50; tentative++) 
    {
      if (this.oAuthService.hasValidAccessToken ()) 
      {
        this.setLocaleFromClaims ();

        //Seul point de passage commun à toutes les connexions, donc seul endroit où demander le
        //jeton de contexte. Attendre avant de naviguer évite que les premiers appels de la page
        //cible partent sans lui ; l’appel n’échoue jamais vers l’appelant, une indisponibilité
        //d’Ammon Permissions ne doit pas empêcher de se connecter.
        await this.jetonContexteService.DemanderSansBloquer ();

        //La langue enregistrée pour l’utilisateur prime sur celle du navigateur ; ne bloque jamais la connexion
        await this.valLangueService.ChargerLangueUtilisateur (this.oAuthService.getIdentityClaims ()?.['locale']);

        //La page cible remplace l’URL du callback, quand elle s’affiche dans la barre d’adresse
        void this.navigationService.Naviguer (url, true);

        return;
      }

      await this.delay (100);
    }
  }

  //Choix mémorisé, sinon claim locale, sinon navigateur, sinon anglais
  private setLocaleFromClaims () : void
  {
    const claims = this.oAuthService.getIdentityClaims();
    this.valLangueService.Initialiser (claims?.['locale']);
  }

  //Execute un delay d’attente
  //  Paramètres
  //    ms : Nombre de milliseconde
  private async delay (ms: number) : Promise<void> 
  {
    return new Promise (resolve => setTimeout (resolve, ms));
  }
}
